export const quotationMarkPixelDot = (
	<svg
		width="44"
		height="44"
		viewBox="0 0 44 44"
		fill="none"
		aria-hidden={true}
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="15" y="2" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="18" y="2" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="9" y="5" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="12" y="5" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="15" y="5" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="18" y="5" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="6" y="8" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="9" y="8" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="12" y="8" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="15" y="8" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="3" y="11" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="6" y="11" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="6" y="14" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="9" y="11" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="9" y="14" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="3" y="14" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="3" y="17" width="2.00001" height="2.00001" fill="currentColor" />
		<rect y="17" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="6" y="17" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="33" y="5" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="30" y="8" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="33" y="8" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="36" y="8" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="36" y="5" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="36" y="2" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="39" y="8" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="39" y="5" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="39" y="2" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="42" y="5" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="42" y="2" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="27" y="11" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="30" y="11" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="33" y="11" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="30" y="17" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="30" y="14" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="33" y="14" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="3" y="26" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="3" y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="3" y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="3" y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="3" y="38" width="2.00001" height="2.00001" fill="currentColor" />
		<rect y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="6" y="23" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="9" y="23" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="12" y="23" width="2.00001" height="2.00001" fill="currentColor" />
		<rect y="20" width="2.00001" height="2.00001" fill="currentColor" />
		<rect y="23" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="3" y="23" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="3" y="20" width="2.00001" height="2.00001" fill="currentColor" />
		<rect y="26" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="6" y="20" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="6" y="26" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="9" y="26" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="12" y="26" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="15" y="26" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="6" y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="6" y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="6" y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="6" y="38" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="6" y="41" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="9" y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="12" y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="15" y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="18" y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="9" y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="9" y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="9" y="38" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="9" y="41" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="12" y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="15" y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="18" y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="12" y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="12" y="38" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="12" y="41" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="15" y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="18" y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="15" y="38" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="30" y="23" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="33" y="23" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="36" y="23" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="27" y="20" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="27" y="23" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="24" y="20" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="24" y="23" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="24" y="26" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="27" y="17" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="24" y="17" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="27" y="14" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="30" y="20" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="27" y="26" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="30" y="26" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="33" y="26" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="36" y="26" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="39" y="26" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="24" y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="27" y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="30" y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="33" y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="36" y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="39" y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="42" y="29" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="24" y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="27" y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="30" y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="33" y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="33" y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="33" y="38" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="33" y="41" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="36" y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="36" y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="36" y="38" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="36" y="41" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="39" y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="39" y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="39" y="38" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="42" y="32" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="42" y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="24" y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="27" y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="30" y="35" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="30" y="38" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="30" y="41" width="2.00001" height="2.00001" fill="currentColor" />
		<rect x="27" y="38" width="2.00001" height="2.00001" fill="currentColor" />
	</svg>
);
